'use client';

import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import { useIfaStore } from '@ifa/store';
import { useState } from 'react';

export function SuccessModal({
    success,
    title,
    onClose = () => {
        void 0;
    },
    children,
}: {
    success: boolean;
    title: string;
    onClose?: () => void;
    children: React.ReactNode;
}) {
    const [open, setOpen] = useState(success);
    const setShouldRefetch = useIfaStore(state => state.table.setShouldRefetch);
    const setShouldShortenPollTimeFromRequest = useIfaStore(state => state.table.setShouldShortenPollTimeFromRequest);

    const handleClose = () => {
        // this will shorten the poll time for the next request be it a new request or a deletion
        setShouldShortenPollTimeFromRequest(true);
        setShouldRefetch(true);
        setOpen(false);
        onClose();
    };

    return (
        <Dialog
            maxWidth="sm"
            open={open}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
            sx={{ p: 4 }}
            data-cy="success-modal-dialog"
        >
            <DialogTitle sx={{ mt: 2 }}>
                {title}
                <IconButton
                    onClick={handleClose}
                    aria-label="close"
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <DialogContentText>{children}</DialogContentText>
            </DialogContent>
            <DialogActions sx={{ mb: 2, mr: 2, ml: 2, justifyContent: 'center' }}>
                <Button variant="contained" onClick={handleClose}>
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    );
}
